import React from 'react'
export const Chart = _ => <h1>Chart!</h1>
export default Chart